export const ACHATS_REDUCER_NAME = 'achats';
